import { useEffect } from "react";

function Home() {
  useEffect(() => {
    document.title = "leah learns";
  }, []);

  return (
    <div>
      <h2>𖦹 About Me</h2>
      <p>
        After 18 years living in Hanoi, Vietnam, I am now a college senior at the University of Richmond, majoring in Computer Science and Mathematics!
      </p>
      <p>
        I describe myself as a fast learner who enjoys applying knowledge to create meaningful things. I love trying new things, pushing myself out of my comfort zone, and learning from the people around me.
      </p>
      <p>
        When I'm not studying, you can find me crocheting, reading mangas, playing nonogram puzzles, making Spotify playlists, drinking boba, redecorating my Notion pages, taking analog pictures, scrapbooking, or learning new food recipes!
      </p>

      <h2>𖦹 Experience</h2>
      <p>
        I've interned at YouTube Live, Google Search, and Mirai Labs, and contributed to projects like developing subgraphs for Ethereum blockchain queries and creating websites for non-profits through Develop for Good. I will be returning to Google as a fulltime software engineer working on YouTube Brand Connect soon!
      </p>
      <p>
        At school, I TA-ed for Computer Science, Math, and Economics classes and participate in competitions like ICPC and CTFs.
      </p>

      <h2>𖦹 Contact</h2>
      <p>
        Please connect with me at <a href="mailto:leah.phw@gmail.com" style={{ textDecoration: 'underline' }}>leah.phw@gmail.com</a> ;)
      </p>
      <p>
        or GitHub: <a href="https://github.com/leahphw" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>github.com/leahphw</a>
      </p>
      <p>
        or LinkedIn: <a href="https://www.linkedin.com/in/phuonganh-le19/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>linkedin.com/in/phuonganh-le19</a>
      </p>
    </div>
  );
}

export default Home;